import { RouterView, type RouteRecordRaw } from "vue-router";
import { RecommendationType } from "@/services/recommendations/recommendations";
import { toURLParam } from "@/utils/recommendations";

const validRecommendationTypeParams = Object.values(RecommendationType).map(
  (recommendationType) => toURLParam(recommendationType),
);

export const recommendationTypeRoute: RouteRecordRaw = {
  path: `/recommendation/:type(${validRecommendationTypeParams.join("|")})`,
  name: "recommendation-details",
  meta: {
    title: "Recommendation Details",
    text: "Recommendations",
    breadcrumb: {
      label: "Recommendation",
      dynamic: true,
      fallback: "Recommendation",
    },
  },
  component: () => import("@/views/Recommendations/RecommendationTaskPage.vue"),
};

export const aiRecommendationDetailRoute: RouteRecordRaw = {
  path: "/ai-recommendation/:taskId(\\d+)",
  name: "ai_recommendation_detail",
  meta: {
    title: "Automagic AI",
    text: "Recommendations",
    breadcrumb: {
      label: "AI recommendation",
      dynamic: true,
      fallback: "AI recommendation",
    },
  },
  component: () =>
    import("@/views/Recommendations/AIRecommendationDetailPage.vue"),
};

export const insightsRoutes: RouteRecordRaw[] = [
  {
    path: "recommendations",
    name: "recommendations",
    redirect: { name: "all-recommendations" },
    meta: {
      activityArea: "recommendations",
      title: "Recommendations",
      text: "Recommendations",
      updated: "2022-01-01",
      icon: "lightbulb",
      description:
        "Discover actionable improvements in your digital marketing. Employ Fyr to make the necessary changes",
      requiresAuth: true,
      isDirect: true,
      breadcrumb: {
        label: "Recommendations",
        to: { name: "all-recommendations" },
      },
    },
    component: RouterView,
    children: [
      {
        path: "",
        name: "all-recommendations",
        meta: { title: "Recommendations", breadcrumb: false },
        component: () => import("@/views/Recommendations/Overview.vue"),
      },
      {
        path: "automations",
        name: "recommendations_automations",
        redirect: {
          name: "organization_settings_automations",
          query: { tab: "recommendations", from: "recommendations" },
        },
        meta: { title: "Automations" },
      },
      recommendationTypeRoute,
      aiRecommendationDetailRoute,
    ],
  },
  // NOTE: the competitor-monitor tree (incl. AI Visibility) is registered
  // once, in sidenav_routes.ts as `competitorMonitorRoute`.
];
